<template>
  <div>
    <b-card no-header class="brief-entrega-abm">
      <form>
        <b-form-group
          label="Link"
          label-for="link"
          :labelCols="labelCols"
          horizontal>
          <b-form-input 
            id="link"
            v-model.trim="$v.link.$model" 
            :state="linkValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="linkFeedback">
            {{ linkInvalidoMsj }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Descripción"
          label-for="descripcion"
          :labelCols="labelCols"
          horizontal>
          <b-form-input 
            id="descripcion"
            v-model.trim="$v.descripcion.$model" 
            :state="descripcionValida"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="descripcionFeedback">
            {{ descripcionInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <br>
        
        <b-form-group
          v-if="!isMuestra"
          label-for="isValidado"
          description="Por ejemplo: demasías, tipografías, calidad de las imágenes, planos, muestras en jpg, etc.">
          <b-form-checkbox 
              id="isValidado"
              v-model="isValidado"
              :value="true"
              :unchecked-value="false">
              <p><b>!ATENCIÓN!</b> ¿Validaste que el archivo cumpla con los requerimientos técnicos solicitados por el proveedor?</p>
          </b-form-checkbox>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button" :disabled="saveDisabled"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefEntrega/getField',
  mutationType: 'briefEntrega/updateField',
});

export default {
  name: 'BriefEntrega',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    briefId: {
      type: Number,
      default: 0
    },
    isMuestra: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      noValidar: true,
      linkValido: null,
      linkInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'descripcion',
      'link',
      'isValidado'
      // 'isDirty',
    ]),
    saveDisabled() {
      if (!this.isMuestra) {
        return !this.isValidado;
      }
      return false;
    }
  },
  created() {
    if ((/true/i).test(this.isMuestra)) {
      let params = {
        briefId: this.briefId,
        briefMuestraId: 0
      }
      this.showSpinner();
      this.$store.dispatch('briefEntrega/inicializarMuestra', params)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    } else {
      let params = {
        briefId: this.briefId,
        briefOriginalId: 0
      }
      this.showSpinner();
      this.$store.dispatch('briefEntrega/inicializarOriginal', params)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'link' || validarTodos) {
        if (this.$v.link.$error) {
          this.linkValido = false;
          if (!this.$v.link.required) {
            this.linkInvalidoMsj = 'Debe ingresar el link solicitado';
          } else if (!this.$v.link.maxLength) {
            this.linkInvalidoMsj = 'El link solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.linkValido = null;
          this.linkInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción solo pueden contener hasta 500 caracteres';
          }      
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.$emit('saved', this.$store.getters['briefEntrega/briefEntrega']);

          // this.showSpinner();
          // this.$store.dispatch('briefEntrega/save')
          //   .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.saved, this.saved, 'light'))
          //   .catch(error => this.showErrorMsj(error))
          //   .finally(() => this.hideSpinner());
        }
      }
    },
    // saved() {
    //   this.$emit('saved', this.$store.getters['briefEntrega/briefEntrega']);
    // },
    cancelar() {
      this.$emit('close')
    },
  },
  validations: {
    link: {
      required,
      maxLength: maxLength(5000)
    },
    descripcion: {
      // required,
      maxLength: maxLength(500)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .brief-entrega-abm .form-group input {
    text-transform: none !important;
  } 
</style>
